import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function QuickReplies({ onInsert, disabled }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState([]);
  const [version, setVersion] = useState(0);
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const load = async () => {
    try { const { data } = await api.get("/quick-replies"); setData(data); setError(""); return data; }
    catch { setError("Não foi possível carregar as respostas rápidas."); return null; }
  };
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try { const { data } = await api.get("/quick-replies"); if (active) { setData(data); setError(""); } }
      catch { if (active) setError("Não foi possível carregar as respostas rápidas."); }
    };
    refresh(); const t = setInterval(refresh, 60000);
    return () => { active = false; clearInterval(t); };
  }, []);
  const edit = async () => {
    if (lock.current) return;
    lock.current = true; setBusy(true);
    const latest = await load();
    if (latest) { setDraft(latest.items.map(i => ({ ...i }))); setVersion(latest.version); setEditing(true); }
    lock.current = false; setBusy(false);
  };
  const save = async e => {
    e.preventDefault(); if (lock.current) return;
    lock.current = true; setBusy(true);
    try {
      const { data: saved } = await api.put("/quick-replies", { items: draft, version });
      setData(current => ({ ...current, items: saved.items, version: saved.version }));
      setEditing(false); toast.success("Respostas da equipe salvas");
    } catch (e) { toast.error(e.response?.data?.detail || "Não foi possível salvar os modelos"); }
    finally { lock.current = false; setBusy(false); }
  };
  const update = (index, field, value) => setDraft(items => items.map((item,i) => i === index ? { ...item, [field]: value } : item));
  return <div className="mb-2 text-xs">
    <button type="button" onClick={() => setOpen(v => !v)} className="rounded border border-pink-500/40 px-3 py-2 text-pink-300" aria-expanded={open}>Respostas rápidas</button>
    {open && <div className="mt-2 rounded border border-slate-700 bg-slate-900 p-3">
      <p className="text-slate-400 mb-2">Escolha um modelo, personalize e revise antes de enviar.</p>
      {error && <p role="alert" className="text-rose-300">{error} <button type="button" className="underline" onClick={load}>Tentar novamente</button></p>}
      {!data && !error && <p>Carregando…</p>}
      <div className="flex flex-wrap gap-2">{data?.items.map((item,i) => <button key={i} type="button" title={item.text} disabled={disabled || busy} onClick={() => onInsert(item.text)} className="rounded bg-pink-600/20 border border-pink-500/30 px-2 py-2 text-pink-200 disabled:opacity-50">{item.title}</button>)}</div>
      {data?.items.length === 0 && <p>Nenhuma resposta cadastrada.</p>}
      {data?.can_edit && <button type="button" disabled={busy} onClick={edit} className="mt-3 underline text-pink-300">Gerenciar modelos da equipe</button>}
    </div>}
    {editing && <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
      <form onSubmit={save} role="dialog" aria-modal="true" aria-labelledby="quick-replies-title" className="w-full max-w-2xl max-h-[85vh] overflow-y-auto rounded-xl border border-pink-500/40 bg-slate-950 p-5 space-y-3">
        <h2 id="quick-replies-title" className="text-lg font-bold text-pink-300">Respostas rápidas da equipe</h2>
        <p>Estes modelos ficam disponíveis para você e suas consultoras.</p>
        {draft.map((item,i) => <fieldset key={i} className="rounded border border-slate-700 p-3 space-y-2">
          <label className="block">Título<input required maxLength={80} value={item.title} disabled={busy} onChange={e => update(i,"title",e.target.value)} className="block w-full rounded bg-slate-800 border border-slate-600 p-2" /></label>
          <label className="block">Mensagem<textarea required maxLength={5000} rows={3} value={item.text} disabled={busy} onChange={e => update(i,"text",e.target.value)} className="block w-full rounded bg-slate-800 border border-slate-600 p-2" /></label>
          <button type="button" disabled={busy} onClick={() => setDraft(items => items.filter((_,index) => index !== i))} className="text-rose-300 underline">Remover modelo</button>
        </fieldset>)}
        <div className="flex flex-wrap gap-3">
          <button type="button" disabled={busy || draft.length >= 50} onClick={() => setDraft(items => [...items, { title: "", text: "" }])} className="rounded border border-slate-600 px-3 py-2">Adicionar modelo</button>
          <button type="submit" disabled={busy} className="rounded bg-pink-600 px-3 py-2">{busy ? "Salvando…" : "Salvar modelos"}</button>
          <button type="button" disabled={busy} onClick={() => setEditing(false)} className="px-3 py-2">Cancelar</button>
        </div>
      </form>
    </div>}
  </div>;
}
